import React from 'react'

export default function Preload() {
    return (
        <div className="preload preload-container">
            <div className="preload-logo"></div>
        </div>
    )
}
